__turbopack_context__.v({
  "container": "search-button-module-scss-module__JanFmG__container",
  "icon": "search-button-module-scss-module__JanFmG__icon",
  "input": "search-button-module-scss-module__JanFmG__input",
  "link": "search-button-module-scss-module__JanFmG__link",
  "placeholder": "search-button-module-scss-module__JanFmG__placeholder",
});
